// =====================================================================
// LA PUERTA DE LA IDENTIDAD · ESTABILIDAD Parte C (F5)
// =====================================================================
// Se monta en `auth.jsx` alrededor de la aplicación. Pregunta UNA vez por
// sesión si a esta persona le toca verificar su empresa y, solo si el
// servidor dice que la identidad está ENCENDIDA y le es OBLIGATORIA, pinta
// el asistente en lugar de la aplicación.
//
// MIENTRAS PREGUNTA, SE PINTA LA APLICACIÓN DE SIEMPRE. Con la identidad
// apagada —el aviso de privacidad en borrador— la respuesta es «apagada»
// y nada cambia: ni una pantalla de espera, ni un campo nuevo. Si la
// pregunta falla, tampoco: el guardián de verdad es el servidor, que
// contesta 403 IDENTIDAD_PENDIENTE a quien de verdad le toca.
import { useEffect, useState } from 'react';
import { api } from '../api';
import AsistenteIdentidad from './AsistenteIdentidad';
import { debeVerAsistenteIdentidad } from './identidad';
import NavegacionDePuerta from '../ui/NavegacionDePuerta';

export default function PuertaIdentidad({ usuario, onSalir, children }) {
  // La respuesta se guarda con DE QUIÉN es: si cambia la persona, la de
  // la anterior deja de contar sin tener que borrarla.
  const [respuesta, setRespuesta] = useState(null);
  const listo = !!usuario && !usuario.debe_cambiar_password && usuario.correo_verificado !== false;
  const quien = usuario ? usuario.id : null;

  useEffect(() => {
    if (!listo) return undefined;
    let vivo = true;
    api.get('/seguridad/identidad/estado')
      .then((e) => { if (vivo) setRespuesta({ quien, estado: e }); })
      .catch(() => { if (vivo) setRespuesta(null); });
    return () => { vivo = false; };
  }, [listo, quien]);

  const estado = listo && respuesta && respuesta.quien === quien ? respuesta.estado : null;

  if (debeVerAsistenteIdentidad(usuario, estado)) {
    return (
      <>
        <AsistenteIdentidad
          estadoInicial={estado}
          onSalir={onSalir}
          onTerminar={() => setRespuesta({ quien, estado: { ...estado, estado: 'COMPLETA', obligatoria: false } })}
        />
        {/* Atrás en esta pantalla avisa antes de salir de TEGO, y pregunta
            si hay algo sin guardar (TC-DR-AT, auditoría H2). */}
        <NavegacionDePuerta />
      </>
    );
  }
  return children;
}
